// import React, { useEffect, useState } from "react";

// /* ---------- Animated Line ---------- */
// const AnimatedLine = ({ path, draw, flow }) => {
//   const length = 500;
//   return (
//     <>
//       <path
//         d={path}
//         stroke="#cbd5e1"
//         strokeWidth="2.5"
//         fill="none"
//         strokeLinecap="round"
//         style={{
//           strokeDasharray: length,
//           strokeDashoffset: draw ? 0 : length,
//           transition: "stroke-dashoffset 0.7s ease",
//         }}
//       />
//     </>
//   );
// };

// /* ---------- Enhanced Box with Visibility Control ---------- */
// const Box = ({ title, value, color, left, top, visible }) => {
//   return (
//     <div
//       className={`absolute flex flex-col items-center justify-center
//       w-[200px] h-[90px] bg-white border rounded-xl
//       shadow-md transition-all duration-700 ease-out
//       ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
//       style={{
//         borderColor: color,
//         left,
//         top,
//       }}
//     >
//       <div className="text-[11px] uppercase font-bold text-gray-400">
//         {title}
//       </div>
//       <div className="text-xl font-bold mt-1" style={{ color }}>
//         {value}
//       </div>
//     </div>
//   );
// };

// export default function RealizationTreeRow({ data }) {
//   const [step, setStep] = useState(0);

//   useEffect(() => {
//     const timers = [
//       setTimeout(() => setStep(1), 100), // Start top lines
//       setTimeout(() => setStep(2), 800), // Show Top Boxes (Approved/Pending)
//       setTimeout(() => setStep(3), 1500), // Start bottom connector lines
//       setTimeout(() => setStep(4), 2200), // Show Bottom Boxes
//       setTimeout(() => setStep(5), 2800), // Start dashed flow
//     ];
//     return () => timers.forEach(clearTimeout);
//   }, []);

//   return (
//     <div className="relative w-[720px] h-[360px] bg-gradient-to-br from-slate-50/70 to-slate-100/70 backdrop-blur-xl rounded-3xl shadow-xl p-4  overflow-hidden">
//       <svg className="absolute inset-0 w-full h-full -top-[17px]">
//         {/* TOP LINES */}
//         <AnimatedLine
//           path="M360 40 L360 80"
//           draw={step >= 1}
//           flow={step >= 5}
//         />
//         <AnimatedLine
//           path="M360 80 L360 110 L260 110 L260 125"
//           draw={step >= 1}
//           flow={step >= 5}
//         />
//         <AnimatedLine
//           path="M360 80 L360 110 L560 110 L560 125"
//           draw={step >= 1}
//           flow={step >= 5}
//         />

//         {/* BOTTOM LINES (Only draw after top boxes appear) */}
//         <AnimatedLine
//           path="M260 200 L260 230 L150 230 L150 260"
//           draw={step >= 3}
//           flow={step >= 5}
//         />
//         <AnimatedLine
//           path="M260 200 L260 230 L370 230 L370 260"
//           draw={step >= 3}
//           flow={step >= 5}
//         />
//       </svg>

//       {/* TOP BOXES */}
//       <Box
//         title="Approved NFA"
//         value={data?.NFA_APPROVED || 5357}
//         color="#16a34a"
//         left={160}
//         top={109}
//         visible={step >= 2}
//       />
//       <Box
//         title="Pending Approval"
//         value={data?.NFA_PENDING || 87}
//         color="#e11d48"
//         left={460}
//         top={109}
//         visible={step >= 2}
//       />

//       {/* BOTTOM BOXES */}
//       <Box
//         title="Approved (Not Retailed)"
//         value={data?.NFA_NOT_RETAILED || 605}
//         color="#64748b"
//         left={60}
//         top={230}
//         visible={step >= 4}
//       />
//       <Box
//         title="Approved (Partially Retailed)"
//         value={data?.NFA_PARTIALLY_APPROVED || 327}
//         color="#0ea5e9"
//         left={280}
//         top={230}
//         visible={step >= 4}
//       />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";

/* ---------- Animated Line ---------- */
const AnimatedLine = ({ path, draw }) => {
  const length = 500;

  return (
    <path
      d={path}
      stroke="#cbd5e1"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      style={{
        strokeDasharray: length,
        strokeDashoffset: draw ? 0 : length,
        transition: "stroke-dashoffset 0.7s ease",
      }}
    />
  );
};

/* ---------- Enhanced Box ---------- */
const Box = ({ title, value, color, left, top, visible, mobileOrder }) => {
  return (
    <div
      className={`
        flex flex-col items-center justify-center
        w-full max-w-[260px] h-[90px]
        bg-white border rounded-xl shadow-md
        transition-all duration-700 ease-out
        
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}

        relative mx-auto
        md:absolute md:w-[200px]
      `}
      style={{
        borderColor: color,
        left: window.innerWidth >= 768 ? left : undefined,
        top: window.innerWidth >= 768 ? top : undefined,
        order: mobileOrder,
      }}
    >
      <div className="text-[11px] uppercase font-bold text-gray-400 text-center px-2">
        {title}
      </div>

      <div className="text-xl font-bold mt-1" style={{ color }}>
        {value}
      </div>
    </div>
  );
};

export default function RealizationTreeRow({ data }) {
  const [step, setStep] = useState(0);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timers = [
      setTimeout(() => setStep(1), 100),
      setTimeout(() => setStep(2), 800),
      setTimeout(() => setStep(3), 1500),
      setTimeout(() => setStep(4), 2200),
      setTimeout(() => setStep(5), 2800),
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div
      className="
        relative
        w-[300px] md:w-[720px]
        min-h-[300px] md:h-[360px]
        bg-gradient-to-br from-slate-50/70 to-slate-100/70
        backdrop-blur-xl rounded-3xl shadow-xl
        p-4 overflow-hidden
      "
    >
      {/* Desktop Lines Only */}
      {isDesktop && (
        <div className="hidden md:block absolute inset-0 pointer-events-none">
          <svg className="absolute inset-0 w-full h-full -top-[17px]">
            {/* TOP LINES */}
            <AnimatedLine path="M360 40 L360 80" draw={step >= 1} />

            <AnimatedLine
              path="M360 80 L360 110 L260 110 L260 125"
              draw={step >= 1}
            />

            <AnimatedLine
              path="M360 80 L360 110 L560 110 L560 125"
              draw={step >= 1}
            />

            {/* BOTTOM LINES */}
            <AnimatedLine
              path="M260 200 L260 230 L150 230 L150 260"
              draw={step >= 3}
            />

            <AnimatedLine
              path="M260 200 L260 230 L370 230 L370 260"
              draw={step >= 3}
            />
          </svg>
        </div>
      )}

      {/* Mobile Layout: Vertical Stack */}
      <div className="flex flex-col gap-4 md:block mt-2 md:mt-0">
        {/* TOP BOXES */}
        <Box
          title="Approved NFA"
          value={data?.NFA_APPROVED || 5357}
          color="#16a34a"
          left={160}
          top={109}
          visible={step >= 2}
          mobileOrder={1}
        />

        <Box
          title="Pending Approval"
          value={data?.NFA_PENDING || 87}
          color="#e11d48"
          left={460}
          top={109}
          visible={step >= 2}
          mobileOrder={2}
        />

        {/* BOTTOM BOXES */}
        <Box
          title="Approved (Not Retailed)"
          value={data?.NFA_NOT_RETAILED || 605}
          color="#64748b"
          left={60}
          top={230}
          visible={step >= 4}
          mobileOrder={3}
        />

        <Box
          title="Approved (Partially Retailed)"
          value={data?.NFA_PARTIALLY_APPROVED || 327}
          color="#0ea5e9"
          left={280}
          top={230}
          visible={step >= 4}
          mobileOrder={4}
        />
      </div>
    </div>
  );
}
